export default "__VITE_ASSET__C0_7QVM1__"